<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Correciones</legend>
          </div>
          <div v-if="!add_item">
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6"></div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <v-data-table :headers="headers" :items="list_usuarios" :expanded.sync="expanded" :single-expand="singleExpand">
                  <template v-slot:item="{item, expand, isExpanded }">
                    <tr>
                      <td>
                        <b-button @click="expand(!isExpanded)" class="btn-s edit mr-2" variant="primary"><i class="fas fa-angle-down"></i></b-button>
                      </td>
                      <td>
                        {{ item.created_at }}
                      </td>
                      <td>
                        {{ item.usuarios.rfc}}
                      </td>
                      <td>
                        {{ item.usuarios.nombres}} {{ item.usuarios.primer_apellido}} {{ item.usuarios.segundo_apellido }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="row p-4">
                        <div class=" col-12">
                          <div class="card ">
                            <div class="card-body">
                              <p>
                                <strong> Motivo </strong>: {{item.motivo}}
                              </p>
                              <p class="m-0">
                                <strong> Cambios realizados por </strong>: {{getUsuario(item.created_by)}}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title">Datos originales</h5>
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(value, key) in item.origen" :key="key"><strong>{{ key.replace("_", " ") }}</strong> : {{returnValueKey(value,key)}}</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div class="col-6">
                          <div class="card">
                            <div class="card-body">
                              <h5 class="card-title">Datos actualizados</h5>
                              <ul class="list-group list-group-flush">
                                <li class="list-group-item" v-for="(value, key) in item.cambio" :key="key"><strong>{{ key.replace("_", " ") }}</strong> : {{returnValueKey(value,key)}}</li>
                              </ul>
                            </div>
                          </div>
                        </div>

                      </div>

                      <div class="col-12" v-if="validarp && item.status===0">
                        <div class="form-group col-md-12">
                          <label class="control-label">Observaciones</label>
                          <textarea class="form-control" type="text" name="observaciones" v-model="movimiento.observaciones" v-validate="item_usuariosValidations.observaciones" placeholder="Motivos/Observaciones"></textarea>
                          <small class="text-danger" v-show="observaciones.invalid">
                            {{ getError('observaciones') }}
                          </small>
                        </div>
                        <div class="row justify-content-end m-3">
                          <button class="btn btn-success" @click.prevent="validar(item)">
                            <span>
                              <i class="fa fa-check"></i> Validar
                            </span>
                          </button>

                          <button class="btn btn-danger ml-3" @click.prevent="rechazar(item)">
                            <span>
                              <i class="fa fa-times"></i> Rechazar
                            </span>
                          </button>
                        </div>
                      </div>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from "vue";
  import moment from "moment";
  import {
    Select,
    Option,
    DatePicker
  } from "element-ui";

  import {
    mapFields
  } from "vee-validate";

  import Domicilio from "../Domicilio.vue";

  Vue.use(Select);
  Vue.use(Option);
  export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    props: ["data"],
    data() {
      return {
        movimiento: {},
        options: [{
            id: 1,
            label: "foo"
          },
          {
            id: 3,
            label: "bar"
          },
          {
            id: 2,
            label: "baz"
          }
        ],
        currentPage: 1,
        perPage: 50,
        validarp: false,
        rows: 0,
        rol: "",
        filter: null,
        id: 1,
        add_item: false,
        edit_item: null,
        tipos: null,
        n_domicilio: null,
        dependencias: null,
        usuarios: null,
        item_usuarios: {},
        list_usuarios: [],
        item_usuariosValidations: {
          rfc: {
            required: true
          },
          curp: {
            required: true
          },
          nombres: {
            required: true
          },
          primer_apellido: {
            required: true
          },
          segundo_apellido: {
            required: true
          },
          ente_publico_id: {
            required: true
          },
          direccion_cargo: {
            required: true
          },
          nivel: {
            required: true
          },
          area_adscripcion: {
            required: true
          },
          honorarios: {
            required: true
          },
          AG172: {
            required: true
          },
          fecha_inicio: {
            required: true
          },
          tipo_baja: {
            required: true
          },
          termina: {
            required: true
          },
          inicia: {
            required: true
          },
          tipo_lic: {
            required: true
          },
          observaciones: {
            required: true
          },
          empleo_cargo_comision: {
            required: true
          },
          observaciones: {
            required: true
          }
        },
        expanded: [],
        singleExpand: true,
        headers: [{
            text: 'Expandir',
            value: 'data-table-expand'
          },
          {
            text: "Fecha",
            value: "created_at",
            align: "center"
          },
          {
            text: "RFC",
            value: "rfc",
            align: "center"
          },
          {
            text: "Nombre",
            value: "nombres",
            align: "center"
          }
        ],
        fields_list: [{
            key: "acciones",
            label: "Acciones",
            thClass: "td-small",
            tdClass: "text-center td-small"
          },
          {
            key: "created_at",
            label: "Fecha",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: value => {
              if (value) return moment(String(value)).format("DD/MM/YYYY");
              else return "";
            }
          },
          {
            key: "usuarios.rfc",
            label: "RFC",
            thClass: "td-medium",
            tdClass: "text-center td-medium",
            formatter: "emptyFields"
          },
          {
            key: "usuarios.nombres usuarios.primer_apellido usuarios.segundo_apellido",
            label: "Nombre",
            tdClass: "text-left",
            formatter: "emptyFields"
          }
        ],
        selects: {
          simple: "",
          movimientos: [{
              value: "1",
              label: "Desactivar servidor"
            },
            {
              value: "2",
              label: "Crear baja "
            },
            {
              value: "3",
              label: "Crear licencia"
            },
            {
              value: "4",
              label: "Crear promoción"
            },
            {
              value: "5",
              label: "Realizar corrección"
            },
            {
              value: "6",
              label: "Cambiar contraseña"
            }
          ]
        }
      };
    },
    computed: {
      ...mapFields([
        "rfc",
        "curp",
        "nombres",
        "primer_apellido",
        "segundo_apellido",
        "ente_publico_id",
        "direccion_cargo",
        "nivel",
        "area_adscripcion",
        "honorarios",
        "AG172",
        "Password",
        "Confirmar",
        "fecha_inicio",
        "tipo_baja",
        "termina",
        "inicia",
        "tipo_lic",
        "observaciones",
        "fecha_posesion",
        "empleo_cargo_comision"
      ]),
      to() {
        let highBound = this.from + this.perPage;
        if (this.total < highBound) {
          highBound = this.total;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      total() {
        //console.log(this.list_usuarios.length);
        this.rows = this.list_usuarios.length;

        return this.list_usuarios.length;
      },
      fullName: {
        get() {
          return `${this.item_usuarios.nombres} ${this.item_usuarios.primer_apellido} ${this.item_usuarios.segundo_apellido}`;
        },
        set(newValue) {
          const m = newValue.match(/(\S*)\s+(.*)/);

          this.nombres = m[1];
          this.primer_apellido = m[2];
          this.segundo_apellido = m[3];
        }
      }
    },
    methods: {
      formato(fecha) {
        return moment(fecha, 'DD/MM/YYYY').format('DD/MM/YYYY');
      },
      returnValueKey(v, k) {
        var resp = "";
        if (k == "dependencia") {
          resp = this.getDependencias(v);
        } else if (k == "honorarios") {
          console.log(typeof v);
          resp = v == 1 ? "HONORARIOS" : "BASE";
        } else if (k == "fecha_posesion") {
          resp = this.formato(v)
        } else if (k == "titular") {
          resp = v == 0 ? "NO" : "SI";
        } else if (k == "simplificada") {
          resp = v == '0' ? "NO" : "SI";
        } else {
          resp = v;
        }
        return resp;
      },
      initItem() {
        this.item_usuarios = {
          acciones: "",
          nombres: "",
          Paterno: "",
          Materno: "",
          User: "",
          Password: ""
        };
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.initItem();
        this.showItem();
        this.edit_item = null;
      },
      validar(item) {
        //this.movimiento.id = item.item.id;
        this.movimiento.id = item.id;
        this.$http.post("aplicaCambio", this.movimiento).then(
          response => {
            //console.log(response)
            if (response.data.error)
              this.StepW("El servidor público tiene una declaración pendiente, no se puede realizar el cambio");
            else
              this.StepOk("Cambio Realizado");
            // this.add_item = !this.add_item;

            this.$http.get("servidores/correcciones").then(
              response => {
                this.list_usuarios = response.data.usuarios;
                // console.log(this.list_usuarios);
                this.movimiento.id = null;
                this.movimiento.observaciones = "";
              },
              error => {
                this.Err(error);
              }
            );
          },
          error => {
            this.StepError(error);
          }
        );
      },
      rechazar(item) {
        //this.movimiento.id = item.item.id;
        this.movimiento.id = item.id;

        this.$http.post("rechazar", this.movimiento).then(
          response => {
            //console.log(response)
            this.StepOk("Cambio Rechazado");
            // this.add_item = !this.add_item;

            this.$http.get("servidores/correcciones").then(
              response => {
                this.list_usuarios = response.data.usuarios;
                // console.log(this.list_usuarios);
                this.movimiento.id = null;
                this.movimiento.observaciones = "";
              },
              error => {
                this.Err(error);
              }
            );
          },
          error => {
            this.StepError(error);
          }
        );
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getDependencias(index) {
        var resp = " ";
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getUsuario(index) {
        var resp = " ";
        if (this.usuarios) {
          this.usuarios.forEach(function (item) {
            if (item.id == index) {
              resp = item.Nombre + " " + item.Paterno + " " + item.Materno;
              return resp;
            }
          });
        }
        return resp;
      }
    },
    created() {
      this.initItem();
      if (this.getKey("permisos").includes(19)) {
        this.validarp = true;
      }
      this.$http.get("servidores/correcciones").then(
        response => {
          this.list_usuarios = response.data.usuarios;
          // console.log(this.list_usuarios);
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("cat_ente_publico").then(
        response => {
          this.dependencias = response.data.entes_publicos;
        },
        error => {
          this.Err(error);
        }
      );
      this.$http.get("usuarios").then(
        response => {
          this.usuarios = response.data.usuarios;
        },
        error => {
          this.Err(error);
        }
      );
    }
  };

</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/Correcciones.vue